<template>
  <div class="navbar fixed z-20 w-full bg-[rgba(106,153,143,.85)]" backdrop-blur-md :class="{ 'slide-up': isNavBarHidden }">
    <div class="navbar-content flex flex-row">
      <div class="site-title flex items-center h-full ml-6" @click.prevent="router.push('/')">Clair Green</div>
      <div class="flex flex-row items-center h-full">
        <router-link to="/" class="link text-base">Home</router-link>
        <NavDropdown :title="'About Me'" :options="aboutMeOptions"></NavDropdown>
        <NavDropdown :title="'My Projects'" :options="projectsOptions"></NavDropdown>
        <router-link to="/skills-experience" class="link text-base">Skills & Experience</router-link>
        <router-link to="/contact" class="link text-base">Contact Me</router-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import NavDropdown from '../global/NavDropdown.vue';
const isNavBarHidden = ref(false);

const router = useRouter();

onMounted(() => {
  window.addEventListener('scroll', handleNavBarVisibility)
  window.addEventListener('mousemove', handleNavBarVisibility)
});
onUnmounted(() => {
  window.removeEventListener('scroll', handleNavBarVisibility)
  window.removeEventListener('mousemove', handleNavBarVisibility)
})

let visibleTimeout: ReturnType<typeof setTimeout> | null = null;

const handleNavBarVisibility = (event?: Event): void => {
  const scrollY = window.scrollY;
  const mouseY = event instanceof MouseEvent ? event.clientY : null;

  if (scrollY > 300 && (mouseY == null || mouseY > 75)) {
    if (visibleTimeout) clearTimeout(visibleTimeout); 
    visibleTimeout = setTimeout(() => {
      isNavBarHidden.value = true;
    }, 300); 
  } 
  else if (scrollY <= 300 || (mouseY !== null && mouseY <= 75)) {
    if (visibleTimeout) clearTimeout(visibleTimeout);
    visibleTimeout = setTimeout(() => {
      isNavBarHidden.value = false;
    }, 100); 
  }
};

const aboutMeOptions = {
  "My Bio": "/about-me",
  "Hobbies & Interests": "/interests"
}

const projectsOptions = {
  "All Projects": "/projects",
  "CV Climbing Hold Classifier": "/climbing-hold-classifier",
  "ArtHuddle": "/art-huddle",
  "clairgreen.com": "/my-website",
  "POVO Class Registration": "/povo-interface",
  "Turn-Based Battle Sim": "/rpg-battle-sim",
  "Eagle Project": "/eagle-project",
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700&display=swap');

.navbar {
  font-family: 'Merriweather', sans-serif;
  transition: transform .5s ease;
}

.navbar.slide-up {
  transform: translateY(-100%);
}

.navbar-content {
  display: flex;
  justify-content: space-between;
  height: 50px;
}

.site-title {
  font-size: 24px;
  font-family: 'Merriweather', sans-serif;
  font-weight: 500;
  color: #eaf2ef;
  text-shadow: 0 0 3px #a8c3b4;
  cursor: pointer;
  transition: transform 0.2s ease-in;
}

.site-title:hover {
  color: #b0cfc2; 
  text-shadow: 0px 0px 3px #90b7a7;
  transform: scale(1.0375)
}

.link,
.links-dropdown {
  text-decoration: none;
  color: #f0f7f2;
  text-shadow: 0px 0px 4px #a8c3b4;
  display: flex;             
  align-items: center;      
  align-self: stretch;        
  height: auto;
  cursor: pointer;
  padding-left: 20px; 
  padding-right: 20px;
}

.link:hover {
  color: #b0cfc2;
  text-shadow: 0px 0px 4px #6a998f;
  transform: scale(1.0375);
  transition: transform 0.5s ease;
}
</style>
